module.exports = __webpack_public_path__ + "static/JB-meta-b0f6fd3e6df619d5c5ec96cb0f9517fc.jpg";